import { useEffect, useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { isAuthSessionActive } from '../../lib/authSession';
import consts from '../../constant';

export default function UnauthorizedPage() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const hasActiveSession = isAuthSessionActive();

  useEffect(() => {
    const frameId = window.requestAnimationFrame(() => {
      setIsVisible(true);
    });

    return () => window.cancelAnimationFrame(frameId);
  }, []);

  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[radial-gradient(circle_at_top,rgba(255,92,58,0.22),transparent_30%),radial-gradient(circle_at_20%_80%,rgba(255,59,29,0.14),transparent_28%),radial-gradient(circle_at_80%_18%,rgba(255,140,92,0.12),transparent_26%),linear-gradient(180deg,#040404_0%,#0b0b0e_48%,#120604_100%)] px-4 py-8 sm:px-6">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:42px_42px] opacity-40"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[26rem] w-[26rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#ff5f38]/10 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute right-[-8rem] top-[-5rem] h-72 w-72 rounded-full bg-[#ff7d59]/10 blur-3xl"
      />

      <section
        className={`relative z-10 w-full max-w-2xl rounded-[2rem] border border-white/10 bg-[linear-gradient(180deg,rgba(18,18,22,0.92),rgba(8,8,10,0.96))] px-6 py-10 text-center shadow-[0_30px_120px_rgba(0,0,0,0.68)] backdrop-blur-xl transition-all duration-700 ease-out sm:px-10 sm:py-12 ${isVisible ? 'translate-y-0 scale-100 opacity-100' : 'translate-y-4 scale-[0.97] opacity-0'}`}
      >
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-[#ff6b4a]/30 bg-[linear-gradient(180deg,rgba(255,82,46,0.22),rgba(255,59,29,0.08))] text-[#ff7b57] shadow-[0_0_40px_rgba(255,79,44,0.18)] sm:mb-8 sm:h-20 sm:w-20">
          <ShieldAlert className="h-8 w-8 sm:h-10 sm:w-10" strokeWidth={2.2} />
        </div>

        <div className="relative">
          <div
            aria-hidden="true"
            className="absolute inset-x-0 top-2 mx-auto h-20 w-48 -translate-y-1/2 rounded-full bg-[#ff5d3a]/20 blur-3xl sm:h-24 sm:w-72"
          />
          <h1 className="relative bg-[linear-gradient(180deg,#ffb19a_0%,#ff6b47_32%,#ff3b1d_70%,#c61d00_100%)] bg-clip-text text-[5.2rem] font-black leading-none tracking-[-0.08em] text-transparent drop-shadow-[0_0_20px_rgba(255,72,37,0.45)] motion-safe:animate-pulse sm:text-[7.5rem]">
            401
          </h1>
        </div>

        <h2 className="mt-3 text-2xl font-bold tracking-tight text-white sm:mt-4 sm:text-4xl">
          Unauthenticated Access
        </h2>

        <p className="mx-auto mt-4 max-w-xl text-sm leading-7 text-[#ffcabf]/78 sm:mt-5 sm:text-base">
          You don&apos;t have permission to access this page. Please login with proper
          credentials.
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:mt-10 sm:flex-row">
          {/* <button
            type="button"
            onClick={() => navigate(hasActiveSession ? '/futures/high-low' : '/authenticating')}
            className="inline-flex min-h-12 w-full items-center justify-center rounded-xl bg-[linear-gradient(135deg,#ff6f4c_0%,#ff3b1d_55%,#c61d00_100%)] px-6 py-3 text-sm font-bold text-white shadow-[0_16px_30px_rgba(255,72,37,0.26)] transition duration-200 hover:brightness-110 active:scale-[0.98] sm:w-auto sm:min-w-[150px]"
          >
            Go Home
          </button> */}

          <button
            type="button"
            onClick={() => window.open(`${consts.CRMUrl}/login`, "_self")}
            className="inline-flex min-h-12 w-full items-center justify-center rounded-xl border border-white/12 bg-white/5 px-6 py-3 text-sm font-semibold text-white/88 transition duration-200 hover:border-[#ff7b57]/40 hover:bg-white/10 hover:text-white active:scale-[0.98] sm:w-auto sm:min-w-[132px]"
          >
            Login
          </button>
        </div>
      </section>
    </main>
  );
}
